import TranslatorFormPage from "./TranslatorFormPage"

const TranslatorCreate = () => {
  return (
    <TranslatorFormPage></TranslatorFormPage>
  )
}

export default TranslatorCreate